
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import BoxStatus from '@/components/BoxStatus.vue';
import Editor from '@/components/Editor.vue';
import { BoxStatusType } from '@/types';

@Component({
  components: { BoxStatus, Editor },
})
export default class MissingFinishings extends Vue {
  @Prop({ type: String, default: null }) readonly status!: BoxStatusType | null;
  @Prop({ type: String, default: null }) readonly notes!: string | null;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

  get notesDisabled(): boolean {
    // Note disattivate quando lo stato è 'Non applicabile' (default)
    return this.status === null || this.status === 'na';
  }

  onStatusChange(val: BoxStatusType) {
    this.$emit('update:status', val);
  }

  onNotesChange(val: string) {
    this.$emit('update:notes', val);
  }
}
